import ModalImplementation from './implementation/ModalImplementation';
var ModalComponent = ModalImplementation;
export default ModalComponent;
//# sourceMappingURL=ModalComponent.js.map